import { components } from "../../pages/apps/forms/formBuilder/PropertiesPanel/FormBuilder";

export const attachTypeDefs = (name: string, v2 = false, sdkName = "") => {
  const a8Window: any = window;
  var key = sdkName === "a8formsV3" ? "a8FormsV3TypeDefs" : "a8FormsTypeDefs"
  if (name && a8Window[name]) {
    const { data: plugin } = a8Window[name]

    if (plugin && plugin.typeDefs) {
      const { typeDefs } = plugin
      let a8FormsTypeDefs = a8Window[key]

      // get the function type def
      const fnTypeDefTokens = typeDefs
        .split("\n")
        .map((el: string) => el.trim())
        .filter((el: string) => el)
      const fnTypeDef = fnTypeDefTokens[fnTypeDefTokens.length - 1]

      // make sure the new funtion type def isn't present already
      if (a8FormsTypeDefs && a8FormsTypeDefs.includes(fnTypeDef)) return;

      // prepend the new typeDef
      a8FormsTypeDefs = typeDefs + "\n" + a8FormsTypeDefs;

      const existingTypeDefTokens = a8FormsTypeDefs
        .split("\n")
        .map((el: string) => el.trim())
        .filter((el: string) => el)

      let openingBraceIdx = -1
      existingTypeDefTokens
        .forEach((el: string, idx: number) => {
          const searchStr = v2 ? (sdkName === "a8formsV3" ? "interface IComponentV3 " : "interface IComponentV2 " ): "interface IComponent "
          if (el.startsWith(searchStr)) {
            openingBraceIdx = idx
            return
          }
        });

      // place the `fnTypeDef` after `openingBraceIdx` position 
      // and flatten out the array
      const updatedTypeDefTokens = existingTypeDefTokens
        .map((token: string, tokenIdx: number) =>
          tokenIdx === openingBraceIdx ? [token, fnTypeDef] : token
        )
        .flat();

      // build the string and update it globally
      a8Window[key] = updatedTypeDefTokens.join("\n")
    }
  }
}

export const attachCoreTypeDefs = (v2 = false, i18n = false) => {

  const core = [
    "Input",
    "InputGroup",
    "CheckBox",
    "CheckList",
    "DocumentCollector",
    "EmailVerification",
    "ImageViewer",
    "Label",
    "Otp",
    "Button",
    "PdfViewer",
    "RadioButton",
    "Scanner",
    "Select",
    "ChainedSelect",
    "StatCounter",
    "Table",
    "Uploader",
    "DatePicker",
    "SignaturePad",
    "Slider",
    "SegmentControl",
    "Tag",
    "Markdown",
    "QandA",
    'BarChart',
    'LineChart',
    "FlatList"
  ]

  if (!i18n) {
    if (v2) {
      components.map(item => item.fields).flat().map(el => el.type).forEach(el => attachTypeDefs(el, v2))
    } else {
      core.forEach(item => attachTypeDefs(item, v2))
    }
  } else {
    return v2 ? components.map(item => item.fields).flat().map(el => el.type) : core
  }
}
